import { useTelescopeContext } from "@hubble/telescope";
import { closeAllModals, goBack } from "~/shared_states/modal";

interface CoinsConfirmationModalProps {
  coinAmount: number;
  currentBalance: number;
  brandLogoUrl: string;
  brandTitle: string;
  onConfirm: () => void;
}

export function CoinsConfirmationModal(props: CoinsConfirmationModalProps) {
  const { components } = useTelescopeContext();

  const handleConfirm = async () => {
    await closeAllModals();
    props.onConfirm();
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <div class="flex w-full flex-col">
      {/* Modal header using Telescope component */}
      <components.ModalHeader
        size="large"
        title={`${props.coinAmount.toLocaleString()} coins will be debited`}
        description={`Current balance: ₹${props.currentBalance.toLocaleString()}`}
        icon={() => (
          <img
            src={props.brandLogoUrl}
            alt={props.brandTitle}
            class="h-full w-full rounded-full object-cover"
          />
        )}
        onClose={handleCancel}
      />

      {/* Modal footer */}
      <div class="border-t border-stroke-1 px-5 py-4">
        <components.Button
          text="Generate card"
          variant="primary"
          style="neutral"
          size={40}
          expanded={true}
          onClick={handleConfirm}
        />
      </div>
    </div>
  );
}
